import React from 'react';
import { NamespaceConsumer } from '@ux/namespace-component';

/**
 * Representation of navigation in a modal.
 *
 * @constructor
 * @public
 */
export default class Nav extends NamespaceConsumer {
  render() {
    return (
      <div className={ this.namespace('modal-nav') }>
        { this.props.children }
      </div>
    );
  }
}
